import { createGlobalStyle } from 'styled-components';
import { Theme } from './Theme';

export const GlobalStyles = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  body {
    font-family: ${Theme.FIRST_FONT};
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  h1, h2, h3 {
    font-family: ${Theme.THIRD_FONT};
  }

  span{
    border: none !important;
    outline: none !important;
  }
`;
